import { put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import { tableAction, tableActions, tableInitialState } from './Table.duck';
import { TenantService } from '../../../services';
import { newMercureMessage } from './App.duck';

export const actionTypes = {
  RequestData: '[FinancialDocumentTemplates] Request',
  FulfilledTable: '[FinancialDocumentTemplates] Fulfilled',
  SearchTable: '[FinancialDocumentTemplates] Search customers',
  ChangePage: '[FinancialDocumentTemplates] change page',
  SetPageSize: '[FinancialDocumentTemplates] set page size',
  SortTable: '[FinancialDocumentTemplates] Sort customers',
  ApplyFilter: '[FinancialDocumentTemplates] Apply filter',
  RemoveFilter: '[FinancialDocumentTemplates] Remove filter',
  ResetFilters: '[FinancialDocumentTemplates] Reset filter',
};

const initialState = {
  ...tableInitialState,
};

export const reducer = (state = initialState, action) => {
  const newState = tableAction(actionTypes, state, action);

  switch (action.type) {
    default:
      return newState;
  }
};

export const actions = {
  ...tableActions(actionTypes),
};

export function* saga() {
  function* reloadData() {
    yield put(actions.requestData());
  }

  yield takeLatest(actionTypes.SearchTable, reloadData);
  yield takeLatest(actionTypes.ChangePage, reloadData);
  yield takeLatest(actionTypes.SetPageSize, reloadData);
  yield takeLatest(actionTypes.SortTable, reloadData);
  yield takeLatest(actionTypes.ApplyFilter, reloadData);
  yield takeLatest(actionTypes.RemoveFilter, reloadData);
  yield takeLatest(actionTypes.ResetFilters, reloadData);

  yield takeLatest(actionTypes.RequestData, function* requestSaga() {
    const currentTenantId = yield select(state => state.AppReducer.tenant.tenantId);

    const currentState = yield select(state => state.FinancialDocumentTemplatesReducer);

    const response = yield TenantService.getFinancialDocumentTemplates(
      currentTenantId,
      currentState.page,
      currentState.pageSize,
      currentState.sortBy,
      currentState.filters,
      currentState.searchQuery,
    );

    yield put(actions.fulfilled(response.data['hydra:member'], response.data['hydra:totalItems']));
  });

  yield takeEvery(newMercureMessage, function* execute(action) {
    if (typeof action.data['@type'] === 'string' && action.data['@type'] === 'FinancialDocumentTemplate') {
      yield put(actions.requestData());
    }
  });
}
